var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 7.26904C1.16699 11.3122 4.70405 14.6558 6.26965 15.9377C6.49371 16.1211 6.60709 16.214 6.77425 16.261C6.90441 16.2977 7.09599 16.2977 7.22616 16.261C7.39363 16.2139 7.50621 16.122 7.73112 15.9378C9.29672 14.6559 12.8336 11.3126 12.8336 7.26941C12.8336 5.73932 12.219 4.27171 11.1251 3.18977C10.0311 2.10783 8.54749 1.5 7.00039 1.5C5.4533 1.5 3.9695 2.10792 2.87554 3.18986C1.78157 4.2718 1.16699 5.73895 1.16699 7.26904Z",
    stroke: "#989DA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 6.5C5.33366 7.42047 6.07985 8.16667 7.00033 8.16667C7.9208 8.16667 8.66699 7.42047 8.66699 6.5C8.66699 5.57953 7.9208 4.83333 7.00033 4.83333C6.07985 4.83333 5.33366 5.57953 5.33366 6.5Z",
    stroke: "#989DA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMarker);
export default __webpack_public_path__ + "static/media/grey-marker.f2c470e91a528ce01b0c103344cfd55c.svg";
export { ForwardRef as ReactComponent };